import React from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { TrendingUp, TrendingDown } from 'lucide-react';

const RecentCalculationsTable = ({ calculations }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })?.format(value || 0);
  };

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
    } catch {
      return dateString;
    }
  };

  if (!calculations || calculations?.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>Nenhum cálculo realizado ainda</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-muted">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Projeto
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Usuário
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Data
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Receita
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Lucro
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Margem
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {calculations?.map((calc) => (
            <tr key={calc?.id} className="hover:bg-muted/50">
              <td className="px-4 py-3 text-sm text-foreground font-medium">
                {calc?.projectName || 'Sem nome'}
              </td>
              <td className="px-4 py-3 text-sm text-muted-foreground">
                {calc?.userName}
              </td>
              <td className="px-4 py-3 text-sm text-muted-foreground">
                {formatDate(calc?.createdAt)}
              </td>
              <td className="px-4 py-3 text-sm text-foreground text-right font-medium">
                {formatCurrency(calc?.totalObra)}
              </td>
              <td className={`px-4 py-3 text-sm text-right font-semibold ${
                calc?.lucroLiquido > 0 ? 'text-success' : 'text-destructive'
              }`}>
                <div className="flex items-center justify-end gap-1">
                  {calc?.lucroLiquido > 0 ? (
                    <TrendingUp className="h-4 w-4" />
                  ) : (
                    <TrendingDown className="h-4 w-4" />
                  )}
                  {formatCurrency(calc?.lucroLiquido)}
                </div>
              </td>
              <td className={`px-4 py-3 text-sm text-right font-semibold ${
                calc?.lucroPercent > 0 ? 'text-success' : 'text-destructive'
              }`}>
                {calc?.lucroPercent?.toFixed(1)}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecentCalculationsTable;